import {ReactUtils} from "@hps/hops-react";
import {IconButton, Tooltip} from "@mui/material";
import React from "react";

import scss from "./IconButton.module.scss";


export default props => (
	<Tooltip arrow={true} title={(props.label || "")}>
		<div className={props.className}>
			<IconButton
				className={(!props.defaultStyling ? scss.IconButton : undefined)}
				classes={props.classes}
				color={props.color}
				disabled={props.disabled}
				onClick={props.onClick}
				size={props.size}
				style={props.style}>
				{ReactUtils.render(props.icon)}
			</IconButton>
		</div>
	</Tooltip>
);
